import React, { useState } from 'react';

const OFFLINE_MESSAGE = (
  <>
    Craggy-GPT (powered by Qwen and trained on scripts from a certain television programme) was created for educational purposes only and is not intended for commercial use. It is currently taking a small sabbatical while the backend is offline. If you’d like updates, or simply want to know more, drop a note to{' '}
    <a href="mailto:ger@yourapp.ie">ger@yourapp.ie</a>.
  </>
);

const CraggyGPT = () => {
  const [craggyInput, setCraggyInput] = useState('');
  const [craggyAnswer, setCraggyAnswer] = useState(OFFLINE_MESSAGE);

  async function askCraggy() {
    if (!process.env.REACT_APP_CRAGGY_ENDPOINT) {
      setCraggyAnswer('CraggyGPT backend not connected yet.');
      return;
    }
  
    setCraggyAnswer('Thinking…');
  
    const res = await fetch(process.env.REACT_APP_CRAGGY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt: craggyInput })
    });
  
    const data = await res.json();
    setCraggyAnswer(data.response);
  }  

  return (
    <div style={{ marginTop: '24px', padding: '16px', border: '1px solid #dee0e4', borderRadius: '8px', maxWidth: '600px', margin: '24px auto' }}>
      <input
        type="text"
        value={craggyInput}
        onChange={(e) => setCraggyInput(e.target.value)}
        placeholder="Craggy-GPT is currently offline"
        disabled
        style={{
          padding: '8px',
          fontSize: '16px',
          border: '1px solid #d0d0d0',
          borderRadius: '4px',
          marginRight: '8px',
          width: '300px',
          backgroundColor: '#f0f0f0',
          color: '#777',
          cursor: 'not-allowed'
        }}
      />
      <button
        onClick={askCraggy}
        disabled
        style={{
          padding: '8px 16px',
          fontSize: '16px',
          backgroundColor: '#e0e0e0',
          color: '#777',
          border: '1px solid #d0d0d0',
          borderRadius: '4px',
          cursor: 'not-allowed',
          opacity: 0.8
        }}
      >
        Ask
      </button>
      <div
        id="craggy-answer"
        style={{
          marginTop: '16px',
          padding: '12px',
          minHeight: '40px',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          backgroundColor: '#f9f9f9'
        }}
      >
        {craggyAnswer}
      </div>
    </div>
  );
}

export default CraggyGPT;

